<template>
  <div class="tabs">
    <div
      v-if="currentTabIndex"
      class="left_block"
      :style="{ left: `calc(${currentTabIndex * 113}px - 6px)` }"
    >
      <div />
    </div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="tab"
      :class="{ tab_active: currentTabIndex == index }"
      @click="changTabs(index)"
    >
      <span v-if="!item.teacher_id">全部内容</span>
      <div v-else class="teacher_cell">
        <div class="avatar_box">
          <img class="avatar" :src="item.avatar" alt="" />
          <div v-if="item.circle_online" class="on_line" />
          <div v-else class="off_line" />
        </div>
        {{ item.nickname }}
      </div>
    </div>
    <div
      class="right_block"
      :style="{ left: `${(currentTabIndex + 1) * 113}px` }"
    >
      <div />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      currentTabIndex: 0,
      list: [],
      circle_id: null,
    };
  },
  mounted() {},
  methods: {
    init(e) {
      this.currentTabIndex = 0;
      const list = [
        {
          teacher_id: null,
        },
      ];
      this.list = list.concat(e.teacherList);
      this.circle_id = e.circle_id;
    },
    changTabs(index) {
      this.currentTabIndex = index;
      this.$parent.getSymbolList({
        circle_id: this.circle_id,
        teacher_id: this.list[this.currentTabIndex].teacher_id,
        symbol: "",
      });
    },
    updateTeacherOnlineStatus(e) {
      const list = this.list;
      for (const item of list) {
        if (item.teacher_id * 1 === e.teacher_id * 1) {
          item.circle_online = e.circle_online;
        }
      }
    },
  },
};
</script>

<style scoped>
.tabs {
  position: relative;
  width: 100%;
  display: flex;
  height: 40px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #dfdfdf;
}

.left_block,
.right_block {
  position: absolute;
  top: 1px;
  width: 6px;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
}

.left_block div,
.right_block div {
  position: absolute;
  top: -1px;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid #dfdfdf;
  z-index: 1;
}

.left_block div {
  border-radius: 0 0 6px 0;
  border-right: 1px solid #dfdfdf;
}

.right_block div {
  border-radius: 0 0 0 6px;
  border-left: 1px solid #dfdfdf;
}

.tab {
  width: 113px;
  height: 100%;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #dfdfdf;
}

.tab_active {
  position: relative;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  background-color: #f9f9f9;
}

.tab_active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background-color: #f9f9f9;
}

.teacher_cell {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
}

.avatar_box {
  position: relative;
  margin-right: 6px;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  object-fit: cover;
  flex-shrink: 0;
}

.on_line,
.off_line {
  position: absolute;
  right: 0;
  bottom: 2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}

.on_line {
  background-color: #10b457;
}

.off_line {
  background-color: #c7c7c7;
}
</style>
